import { ModuleDisabled } from "../ModuleDisabled";

export const ComponentDependOnFeatureEnabled = (props: {
    ComponentToDisplay: JSX.Element;
    componentEnabled: boolean;
  }): JSX.Element => {
    return props.componentEnabled ? props.ComponentToDisplay : <ModuleDisabled />;
  };